import React from 'react';
import CentralColumn from '../../../DeviationPage/_partials/CentralColumn';
import CommissionCover from './CommissionCover';
import { getDeviationTitle } from '../../_helpers';
import s from './Commission.scss';
export const CommissionFullView = ({ deviation  })=>{
    const deviationTitle = getDeviationTitle(deviation);
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(CentralColumn, null, /*#__PURE__*/ React.createElement(CommissionCover, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement("h1", {
        className: s['header']
    }, deviationTitle)));
};
CommissionFullView.displayName = 'CommissionFullView';
export default CommissionFullView;
